import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

import { IAutocompleteOption } from 'app/models/filter.models';

export const makeControlDirty = (control: AbstractControl): void => {
  if (!control.dirty) {
    control.markAsDirty();
  }
};

export const mapValuesToOptions = (values?: string[]): IAutocompleteOption[] =>
  values?.map((v) => ({
    id: v,
    value: v,
  })) ?? [];

export const atLeastOneValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const group = control as FormGroup;
  let isAllEmpty = true;

  Object.keys(group.controls).forEach((key) => {
    const control = group.get(key);

    if (control && control.value !== '' && control.value !== null) {
      isAllEmpty = false;
    }
  });

  return isAllEmpty ? { atLeastOneRequired: true } : null;
};
